import type { fetchRealties, fetchRealtyTypes } from '../api/realty/realty-api';

export type RealtyListingSeed = {
  locale: string;
  filterKey: string;
  fetchedAt: number;
  realties?: Awaited<ReturnType<typeof fetchRealties>>;
  types?: Awaited<ReturnType<typeof fetchRealtyTypes>>;
};

export function realtySearchParamsFromRecord(
  record: Record<string, string | string[] | undefined>,
) {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(record)) {
    for (const item of Array.isArray(value) ? value : value === undefined ? [] : [value]) {
      params.append(key, item);
    }
  }
  return params;
}

// A persisted component can outlive its first URL. Never seed another filter or locale.
export function matchingRealtyListingSeed(
  seed: RealtyListingSeed | undefined,
  locale: string,
  filterKey: string,
) {
  return seed?.locale === locale && seed.filterKey === filterKey ? seed : undefined;
}
